import { removeIncompatibleSearchParameters } from "@helpers/removeIncompatibleSearchParameters"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const historicalDataPageSearchSchema = z.object({
	vessel: z.optional(z.string()).catch(undefined), //TODO: find a way to get list of vessels
})

export const Route = createFileRoute("/clients/$clientName/_sopPageLayout/historical-data")({
	component: RouteComponent,
	validateSearch: historicalDataPageSearchSchema,
	search: {
		middlewares: [removeIncompatibleSearchParameters(historicalDataPageSearchSchema)],
	},
})

function RouteComponent() {
	return null
}
